

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>





<br>
<br><br>
<!-- Disclaimer Hero Section -->
<section class="privacy-hero">
  <div class="hero-overlay">
    <h1>Disclaimer</h1>
  </div>
</section>

<!-- Disclaimer Content Section -->
<section class="privacy-content container">
  <div class="policy-section">
    
    <p>Baabuji Venturess Pvt Ltd (“Company”, “we”, “our”, “us”), operating the Facheck platform (https://facheck.in & https://facheck.biz) (the “Platform”), provides API-based digital KYC verification services, digital document signing solutions, and related infrastructure services to business entities (“Clients”). This Disclaimer governs the use of the Platform and the services provided therein. </p>
<p>The Company operates strictly as a technology intermediary and facilitator, enabling secure transmission of data between Clients and various third-party or government-authorized verification sources. The Company does not own, control, or maintain any of the underlying databases used for verification services, including but not limited to PAN, Aadhaar, GST, CIN, DIN, bank account, or FASTag data sources. All verification results made available through the Platform are obtained from external systems and are relayed to Clients on an “as-is” and “as-available” basis.  </p>
<p>The Company does not guarantee, represent, or warrant the accuracy, completeness, reliability, timeliness, or validity of any data, responses, or verification results obtained through the Platform. Any discrepancies, errors, delays, or outdated information arising from third-party sources are beyond the control of the Company. Clients acknowledge and agree that they must independently verify and validate any information received through the Platform before relying on it for making business, financial, legal, or compliance-related decisions. </p>
<p>The Platform is provided for general informational and facilitation purposes only and does not constitute legal, financial, regulatory, or professional advice. The Company shall not be responsible or liable for any actions taken or decisions made by Clients or any third parties based on the use of the Platform or the data obtained through it.  </p>
<p>The Company expressly disclaims all liability for any direct, indirect, incidental, consequential, special, or punitive damages, including but not limited to loss of profits, loss of business opportunities, reputational harm, or regulatory penalties, arising out of or in connection with the use of the Platform, reliance on verification results, or inability to access the services. </p>
<p>Clients are solely responsible for ensuring that they have obtained all necessary consents, authorizations, and legal permissions from end users prior to submitting their data for verification or processing through the Platform. The Company shall not be held responsible for any misuse, unauthorized processing, or unlawful collection of personal data by Clients. </p>
<p>While the Company implements robust security measures, including encryption and access controls, it does not warrant that the Platform will be completely free from interruptions, errors, vulnerabilities, or cyber threats. Use of the Platform is at the Client’s own risk, and the Company shall not be liable for any loss or damage resulting from security breaches, system failures, or external attacks beyond its reasonable control. </p>
<p>The Company reserves the right to modify, suspend, or discontinue any part of the Platform or services at any time without prior notice. This Disclaimer may also be updated periodically, and continued use of the Platform shall constitute acceptance of any such changes. </p>

 <p>
For any questions or concerns regarding this Disclaimer, you may contact: 

    </p>
    <ul>
      <li>Email: <a href="mailto:support@facheck.in">support@facheck.in</a></li>
      <li>Company: Baabuji Venturess Pvt Ltd</li>
    </ul>
  </div>

  

  
</section>

 






